/**
 * Blog category slugs that exist in BOTH languages, i.e. `/blog/category/{slug}`
 * and `/bn/blog/category/{slug}` both resolve. Only these get reciprocal
 * hreflang tags — pointing crawlers at a Bangla URL that 404s is worse than
 * emitting no alternate at all.
 *
 * Derived from the English categories in `src/content/posts.ts` intersected
 * with `BN_CATEGORY_SLUGS` in `src/content/bn/categories.ts`.
 * Keep in sync when a category is added on either side.
 */
export const PAIRED_CATEGORY_SLUGS = new Set<string>(["local-seo", "aeo"]);

export function isPairedCategory(slug: string) {
  return PAIRED_CATEGORY_SLUGS.has(slug.toLowerCase());
}

/**
 * Cities that have a Bangla counterpart at `/bn/seo-services/{slug}` (and the
 * five programmable service children). Kept here as plain slugs so English
 * routes can emit reciprocal hreflang without importing Bangla content.
 * Keep in sync with `BN_LOCATIONS` in `src/content/bn/locations.ts`.
 */
export const PAIRED_CITY_SLUGS = new Set<string>([
  "tangail",
  "feni",
  "noakhali",
  "kushtia",
  "nilphamari",
]);

export function isPairedCity(slug: string) {
  return PAIRED_CITY_SLUGS.has(slug);
}
